<template>
  <div>
    <div v-if="currentCompareciente_.persona == 'Persona Física' || currentCompareciente_.persona == 'Física'">
      <table class="tabla" style="border-collapse: collapse !important">
        <tr>
          <td>
            <img :src="urlBanner" class="logo" />
          </td>
          <td>
            <table class="tabla" style="border-collapse: collapse !important">
              <tr class="firstline">
                <td colspan="8" class="section" style="background-color: white; color: black">
                  DECLARO, BAJO PROTESTA DE DECIR VERDAD, QUE LOS DATOS ASENTADOS SON VERDADEROS
                </td>
              </tr>
              <tr class="space" style="height: 50px"></tr>
              <tr>
                <td colspan="3" class="space" style="width: 20%"></td>
                <td
                  colspan="3"
                  class="user"
                  style="width: 60%; background-color: white !important; border-bottom: solid 2px black"
                ></td>
                <td colspan="2" class="space" style="width: 20%"></td>
              </tr>
              <tr>
                <td colspan="3" class="space" style="width: 20%"></td>
                <td
                  colspan="3"
                  style="
                    width: 60%;
                    vertical-align: top;
                    font-size: 14px;
                    text-align: center;
                    background-color: white;
                    font-weight: bold;
                  "
                >
                  NOMBRE Y FIRMA
                </td>
                <td colspan="2" class="space" style="width: 20%"></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <div id="seccion_uno">
        <table class="tabla">
          <tr>
            <th colspan="10" class="section">FORMATO DE IDENTIFICACIÓN DE CLIENTES - PERSONAS FÍSICAS</th>
          </tr>

          <tr class="firstline">
            <td class="title">Mexicano</td>
            <td class="select">
              <h3 v-if="currentCompareciente_.estatus_migratorio == 'Mexicano'" class="filledcircle"></h3>
              <h3 v-else class="circle"></h3>
            </td>
            <td class="space" style="width: 5%"></td>
            <td class="title">Extranjero Visitante</td>
            <td class="select">
              <h3 v-if="currentCompareciente_.estatus_migratorio == 'Extranjero'" class="filledcircle"></h3>
              <h3 v-else class="circle"></h3>
            </td>
            <td class="space" style="width: 5%"></td>
            <td class="right-title">Fecha:</td>
            <td class="user" style="width: 30%">
              {{ fecha }}
            </td>
          </tr>
          <tr>
            <td class="title">
              Residente Temporal o
              <br />
              Permanente
            </td>
            <td class="select">
              <h3 v-if="currentCompareciente_.estatus_migratorio == 'Residente Temporal'" class="filledcircle"></h3>
              <h3 v-else class="circle"></h3>
            </td>
            <td class="space" style="width: 5%"></td>
          </tr>
        </table>
      </div>

      <div id="seccion_dos">
        <table class="tabla">
          <tr>
            <th colspan="8" class="section" style="width: 100%">DATOS GENERALES DE IDENTIFICACIÓN</th>
          </tr>
          <tr class="firstline">
            <td class="title" style="width: 15%">Nombre y apellidos:</td>
            <td colspan="7" class="user" style="width: 80%">
              {{ currentCompareciente_.nombre }}
              {{ currentCompareciente_.paterno }}
              {{ currentCompareciente_.materno }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 10%">Fecha de Nacimiento:</td>
            <td colspan="1" class="user" style="width: 30%">
              {{ currentCompareciente_.fecha_nacimiento }}
            </td>
            <td class="right-title" style="width: 11.5%">Sexo:</td>
            <td class="user" colspan="3" style="width: 7.5%">
              {{ currentCompareciente_.sexo }}
            </td>
            <td class="right-title" style="width: 10%">Alias/AKA:</td>
            <td class="user" style="width: 25%">
              {{ currentCompareciente_.alias }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Lugar de Nacimiento:</td>
            <td class="title" style="width: 7.5%">Ciudad:</td>
            <td class="user" style="width: 10%">
              {{ currentCompareciente_.lugar_nacim_ciudad }}
            </td>
            <td class="right-title" style="width: 7.5%">Estado:</td>
            <td colspan="2" class="user" style="width: 10%">
              {{ currentCompareciente_.lugar_nacim_estado }}
            </td>
            <td class="right-title" style="width: 10%">País:</td>
            <td class="user" style="width: 15%">
              {{ currentCompareciente_.lugar_nacim_pais }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Nacionalidades:</td>
            <td colspan="7" class="user" style="width: 80%">
              {{ currentCompareciente_.nacionalidades_nombres }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Actividad / Profesión:</td>
            <td colspan="3" class="user" style="width: 30%">
              {{ currentCompareciente_.ocupacion }}
            </td>
            <td colspan="2" class="right-title" style="width: 15%">Giro de negocios:</td>
            <td colspan="2" class="user" style="width: 35%">
              {{ currentCompareciente_.giro_negocios }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">CURP o equivalente:</td>
            <td colspan="3" class="user" style="width: 30%">
              {{ currentCompareciente_.curp }}
            </td>
            <td colspan="2" class="right-title" style="width: 15%">RFC o Tax ID:</td>
            <td colspan="2" class="user" style="width: 35%">
              {{ currentCompareciente_.rfc }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Identificación:</td>
            <td class="title" style="width: 7.5%">Tipo:</td>
            <td colspan="2" class="user" style="width: 12.5%">
              {{ currentCompareciente_.identificacion_tipo }}
            </td>
            <td colspan="2" class="right-title" style="width: 15%">Autoridad que expide:</td>
            <td colspan="2" class="user" style="width: 35%">
              {{ currentCompareciente_.identificacion_autoridad }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%"></td>
            <td class="title" style="width: 7.5%">Número:</td>
            <td colspan="6" class="user" style="width: 72.5%">
              {{ currentCompareciente_.identificacion_numero }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Estado Civil:</td>
            <td colspan="3" class="user" style="width: 30%">
              {{ currentCompareciente_.estado_civil }}
            </td>
            <td colspan="2" class="right-title" style="width: 15%">Régimen patrimonial</td>
            <td colspan="2" class="user" style="width: 35%">
              {{ currentCompareciente_.regimen_patrimonial }}
            </td>
          </tr>
          <tr class="firstline">
            <td class="title" style="width: 15%">Nombre del Cónyuge:</td>
            <td colspan="7" class="user" style="width: 80%">
              {{ currentCompareciente_.identificacion_conyuge }}
            </td>
          </tr>
        </table>
      </div>

      <div style="height: 150px; background-color: gainsboro"></div>

      <div id="seccion_tres" class="new-page">
        <table class="tabla">
          <tr class="firstline">
            <th colspan="8" class="section">DOMICILIO PARTICULAR DE LA PERSONA FÍSICA</th>
          </tr>
          <div v-for="domicilio in currentCompareciente_.domicilios" :key="domicilio.id">
            <div v-if="domicilio.tipo == 'Particular' || domicilio.tipo == 'Particular y Fiscal'">
              <tr>
                <td class="title" style="width: 15%">Calle / Avenida / Vía:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.calle }}
                </td>
                <td colspan="1"></td>
                <td rowspan="8" class="maps" style="width: 50%" valign="center">
                  <img
                    width="auto"
                    height="180px"
                    :src="`https://maps.googleapis.com/maps/api/staticmap?center=${domicilio.lat},${domicilio.lng}&zoom=17&scale=1&size=600x300&maptype=roadmap&format=png&visual_refresh=true&markers=color:red%7Alabel:C%7C${domicilio.lat},${domicilio.lng}&key=${googleApiKey}`"
                  />
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Número Exterior:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.num_exterior }}
                </td>
                <td class="right-title" style="width: 7.5%">Interior:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.num_interior }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Alcaldía / Municipio:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.delegacion_municipio }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Entidad Federativa:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.entidad }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Colonia o Urbanización:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.colonia }}
                </td>
                <td class="right-title" style="width: 7.5%">CP:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.codigo_postal }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 7.5%">País:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.pais }}
                </td>
              </tr>
            </div>
          </div>
        </table>

        <table class="tabla">
          <tr class="firstline">
            <td colspan="8" class="section">DOMCILIO FISCAL</td>
          </tr>
          <div v-for="domicilio in currentCompareciente_.domicilios" :key="domicilio.id">
            <div v-if="domicilio.tipo == 'Fiscal'">
              <tr>
                <td class="title" style="width: 15%">Calle / Avenida / Vía:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.calle }}
                </td>
                <td colspan="1"></td>
                <td rowspan="8" class="maps" style="width: 50%" valign="center">
                  <img
                    width="auto"
                    height="180px"
                    :src="`https://maps.googleapis.com/maps/api/staticmap?center=${domicilio.lat},${
                      domicilio.lng
                    }&zoom=17&scale=1&size=600x300&maptype=roadmap&format=png&visual_refresh=true&markers=color:red%7Alabel:C%7C${
                      domicilio.lat
                    },${domicilio.lng}&key=${googleApiKey}`"
                  />
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Número Exterior:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.num_exterior }}
                </td>
                <td class="right-title" style="width: 7.5%">Interior:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.num_interior }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Alcaldía / Municipio:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.delegacion_municipio }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Entidad Federativa:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.entidad }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Colonia o Urbanización:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.colonia }}
                </td>
                <td class="right-title" style="width: 7.5%">CP:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.codigo_postal }}
                </td>
              </tr>
              <tr>

                <td class="title" style="width: 7.5%">País:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.pais }}
                </td>
              </tr>
            </div>
          </div>
        </table>
      </div>

      <div id="seccion_cuatro">
        <table class="tabla">
          <tr class="firstline">
            <td colspan="4" class="section">DATOS DE CONTACTO Y REDES DE LA PERSONA FÍSICA</td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Teléfono Fijo:</td>
            <td class="user" style="width: 50%">
              {{ currentCompareciente_.telefonoFijo }}
            </td>
            <td class="right-title" style="width: 10%">Facebook:</td>
            <td class="user" style="width: 25%">
              {{ currentCompareciente_.facebook }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Celular:</td>
            <td class="user" style="width: 50%">
              {{ currentCompareciente_.telefonoCelular }}
            </td>
            <td class="right-title" style="width: 10%">Instagram:</td>
            <td class="user" style="width: 25%">
              {{ currentCompareciente_.instagram }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Correo electrónico:</td>
            <td class="user" style="width: 50%">
              {{ currentCompareciente_.email }}
            </td>
            <td class="right-title" style="width: 15%">Twitter:</td>
            <td class="user" style="width: 50%">
              {{ currentCompareciente_.twitter }}
            </td>
          </tr>
        </table>
      </div>

      <div id="seccion_cinco">
        <table class="tabla">
          <tr class="firstline">
            <td colspan="8" class="section">EN CASO DE PERSONAS FÍSICAS EXTRANJERAS: DOMICILIO DE CONTACTO EN MÉXICO</td>
          </tr>
          <div v-for="domicilio in currentCompareciente_.domicilios" :key="domicilio.id">
            <div v-if="domicilio.tipo == 'Extranjero'">
              <div v-if="domicilio.calle === 'No aplica'">
                <table class="tabla" style="border-collapse: collapse !important">
                  <tr class="section-empty">
                    <td>No aplica</td>
                  </tr>
                </table>
              </div>
              <div v-else>
                <tr>
                  <td class="title" style="width: 15%">Calle / Avenida / Vía:</td>
                  <td colspan="3" class="user" style="width: 45%">
                    {{ domicilio.calle }}
                  </td>
                  <td class="right-title" style="width: 15%">Num. Exterior:</td>
                  <td class="user" style="width: 8.33%">
                    {{ domicilio.num_exterior }}
                  </td>
                  <td class="right-title" style="width: 8.33%">Num. Interior:</td>
                  <td class="user" style="width: 8.33%">
                    {{ domicilio.num_interior }}
                  </td>
                </tr>
                <tr>
                  <td class="title" style="width: 15%">Colonia o Urbanización:</td>
                  <td colspan="3" class="user" style="width: 45%">
                    {{ domicilio.colonia }}
                  </td>
                  <td class="right-title" style="width: 15%">Alcaldía / Municipio:</td>
                  <td colspan="3" class="user" style="width: 30%">
                    {{ domicilio.delegacion_municipio }}
                  </td>
                </tr>
                <tr>
                  <td class="right-title" style="width: 10%">Código Postal:</td>
                  <td class="user" style="width: 10%">
                    {{ domicilio.codigo_postal }}
                  </td>
                  <td class="right-title" style="width: 15%">Entidad Federativa:</td>
                  <td colspan="3" class="user" style="width: 30%">
                    {{ domicilio.entidad }}
                  </td>
                </tr>
              </div>
            </div>
          </div>
        </table>
      </div>

      <div id="seccion_seis">
        <table class="tabla">
          <tr class="firstline">
            <td colspan="8" class="section">EN CASO DE ACTUAR REPRESENTANDO - DATOS GENERALES DEL APODERADO</td>
          </tr>
          <div v-if="currentCompareciente_.representantes !== 'No aplica'">
            <div v-if="currentCompareciente_.representantes[0].nombre === 'No aplica'">
              <table class="tabla" style="border-collapse: collapse !important">
                <tr class="section-empty">
                  <td>No aplica</td>
                </tr>
              </table>
            </div>
            <div v-else>
              <tr>
                <td class="title" style="width: 15%">Nombre y apellidos:</td>
                <td colspan="7" class="user" style="width: 85%">
                  {{ currentCompareciente_.representantes[0].nombre }}
                  {{ currentCompareciente_.representantes[0].paterno }}
                  {{ currentCompareciente_.representantes[0].materno }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="title" style="width: 20%">Fecha y Lugar de Nacimiento:</td>
                <td class="user" style="width: 40%">
                  {{ currentCompareciente_.representantes[0].fecha_nacimiento }}
                  {{ currentCompareciente_.representantes[0].lugar_nacim_ciudad }}
                  {{ currentCompareciente_.representantes[0].lugar_nacim_estado }}
                  {{ currentCompareciente_.representantes[0].lugar_nacim_pais }}
                </td>
                <td class="right-title" style="width: 8.33%">RFC:</td>
                <td class="user" style="width: 15%">
                  {{ currentCompareciente_.representantes[0].rfc }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="title" style="width: 20%">Datos de la escritura de poderes:</td>
                <td class="user" style="width: 40%">
                  <div v-if="currentCompareciente_.representantes.length > 0">
                    <span v-if="currentCompareciente_.representantes[0].instrumento_numero == 'No aplica'">
                      {{ currentCompareciente_.representantes[0].instrumento_numero }}
                    </span>
                    <span class="info" v-else>
                      Constancia del instrumento público número
                      {{ currentCompareciente_.representantes[0].instrumento_numero }}, de fecha
                      {{ currentCompareciente_.representantes[0].instrumento_numero_fecha }}
                      , otorgada ante la fe del licenciado
                      {{ currentCompareciente_.representantes[0].instrumento_fedatario_nombre }}, número
                      {{ currentCompareciente_.representantes[0].instrumento_fedatario_numero }}
                      de
                      {{ currentCompareciente_.representantes[0].instrumento_fedatario_estado }}
                    </span>
                  </div>
                </td>
                <td class="right-title" style="width: 8.33%">CURP:</td>
                <td colspan="3" class="user" style="width: 31.66%">
                  {{ currentCompareciente_.representantes[0].curp }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 10%">Domicilio:</td>
                <td colspan="6" class="user" style="width: 90%">
                  <div v-if="currentCompareciente_.representantes.length > 0">
                    <span>
                      {{ currentCompareciente_.representantes[0].domicilios[0].calle }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].num_exterior }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].num_interior }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].colonia }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].delegacion_municipio }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].entidad }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].pais }}
                      {{ currentCompareciente_.representantes[0].domicilios[0].codigo_postal }}
                    </span>
                  </div>
                </td>
              </tr>
            </div>
          </div>
          <div v-else-if="currentCompareciente_.representantes === 'No aplica'">
            <table class="tabla" style="border-collapse: collapse !important">
              <tr class="section-empty">
                <td>No aplica</td>
              </tr>
            </table>
          </div>
        </table>
      </div>
    </div>

    <div v-else>
      <table class="tabla" style="border-collapse: collapse !important">
        <tr>
          <td>
            <img :src="urlBanner" class="logo" />
          </td>
          <td>
            <table class="tabla" style="border-collapse: collapse !important">
              <tr class="firstline">
                <td colspan="8" class="section" style="background-color: white; color: black">
                  DECLARO, BAJO PROTESTA DE DECIR VERDAD, QUE LOS DATOS ASENTADOS SON VERDADEROS
                </td>
              </tr>
              <tr class="space" style="height: 40px"></tr>
              <tr>
                <td colspan="3" class="space" style="width: 20%"></td>
                <td
                  colspan="3"
                  class="user"
                  style="width: 60%; background-color: white !important; border-bottom: solid 2px black"
                ></td>
                <td colspan="2" class="space" style="width: 20%"></td>
              </tr>
              <tr>
                <td colspan="3" class="space" style="width: 20%"></td>
                <td
                  colspan="3"
                  style="
                    width: 60%;
                    vertical-align: top;
                    font-size: 14px;
                    text-align: center;
                    background-color: white;
                    font-weight: bold;
                  "
                >
                  NOMBRE Y FIRMA
                </td>
                <td colspan="2" class="space" style="width: 20%"></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <div id="seccion_uno">
        <table class="tabla">
          <tr>
            <th colspan="10" class="section">FORMATO DE IDENTIFICACIÓN DE CLIENTES - PERSONAS MORALES</th>
          </tr>
          <tr class="firstline">
            <td class="title">Persona Moral Mexicana</td>
            <td class="select">
              <h3 class="filledcircle" v-if="currentCompareciente_.nacionalidades_nombres == 'México'"></h3>
              <h3 class="circle" v-else></h3>
            </td>

            <td class="space" style="width: 5%"></td>
            <td class="title">Persona Moral Extranjera</td>
            <td class="select" style="width: 5%">
              <h3 class="filledcircle" v-if="currentCompareciente_.nacionalidades_nombres != 'México'"></h3>
              <h3 class="circle" v-else></h3>
            </td>
            <td class="space"></td>
            <td class="right-title">Fecha:</td>
            <td class="user" style="width: 30%">
              {{ fecha }}
            </td>
          </tr>
        </table>
      </div>

      <div id="seccion_dos">
        <table class="tabla">
          <tr>
            <th colspan="8" class="section" style="width: 100%">DATOS GENERALES DE IDENTIFICACIÓN</th>
          </tr>
          <tr class="firstline">
            <td class="title" style="width: 15%">Denominación Social:</td>
            <td colspan="7" class="user" style="width: 80%">
              {{ currentCompareciente_.denominacion_social }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Fecha de Constitución:</td>
            <td colspan="3" class="user" style="width: 30%">
              <!-- {{ currentCompareciente_.fecha_constitucion.substr(0, 10) }} -->
              {{ currentCompareciente_.fecha_constitucion }}
            </td>
            <td class="right-title" style="width: 7.5%">Nacionalidad:</td>
            <td class="user" style="width: 7.5%">
              {{ currentCompareciente_.nacionalidades_nombres }}
            </td>
            <td class="right-title" style="width: 10%">RFC o Tax ID:</td>
            <td class="user" style="width: 25%">
              {{ currentCompareciente_.rfc }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Actividad o Giro de Negocios:</td>
            <td colspan="4" class="user" style="width: 30%">
              {{ currentCompareciente_.actividad }}
            </td>
            <td class="right-title" style="width: 15%">Domicilio Social:</td>
            <td colspan="2" class="user" style="width: 35%">
              {{ currentCompareciente_.domicilio_social }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%; vertical-align: top">Objeto Social:</td>
            <td
              colspan="7"
              class="verifycheck"
              style="text-align: left; vertical-align: top; font-weight: lighter; font-size: 12px; width: 65%; height: 80px"
            >
              {{ currentCompareciente_.objeto_social }}
            </td>
          </tr>
        </table>
      </div>

      <div id="seccion_tres">
        <table class="tabla">
          <tr class="firstline">
            <td colspan="8" class="section" style="width: 10%">DATOS DE CONSTITUCIÓN DE PERSONA MORAL MEXICANA</td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Instrumento Número:</td>
            <td colspan="2" class="user" style="width: 20%">
              {{ currentCompareciente_.instrumento_numero }}
            </td>
            <td class="right-title" style="width: 15%">De fecha:</td>
            <td colspan="2" class="user" style="width: 17.5%">
              <!-- {{ currentCompareciente_.instrumento_numero_fecha.substr(0, 10) }} -->
              {{ currentCompareciente_.instrumento_numero_fecha }}
            </td>
            <td class="right-title" style="width: 15%">Fedatario:</td>
            <td class="user" style="width: 17.5%">
              {{ currentCompareciente_.instrumento_fedatario }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Nombre del Fedatario:</td>
            <td colspan="3" class="user" style="width: 35%">
              {{ currentCompareciente_.instrumento_fedatario_nombre }}
            </td>
            <td class="right-title" style="width: 8.75%">Número</td>
            <td class="user" style="width: 8.75%">
              {{ currentCompareciente_.instrumento_fedatario_numero }}
            </td>
            <td class="right-title" style="width: 15%">Lugar:</td>
            <td class="user" style="width: 17.5%">
              {{ currentCompareciente_.instrumento_fedatario_estado }}
            </td>
          </tr>
          <tr>
            <td colspan="2" class="title" style="width: 30%">Datos de Inscripción en el RPC - Folio Número:</td>
            <td colspan="2" class="user" style="width: 20%">
              {{ currentCompareciente_.instrumento_rpf_folio }}
            </td>
            <td colspan="2" class="right-title" style="width: 17.5%">Fecha y Lugar:</td>
            <td colspan="2" class="user" style="width: 32.5%">
              <!-- {{ currentCompareciente_.instrumento_rpf_folio_fecha.substr(0, 10) }} -->
              {{ currentCompareciente_.instrumento_rpf_folio_fecha }}
              {{ currentCompareciente_.instrumento_rpf_folio_lugar }}
            </td>
          </tr>
        </table>
      </div>

      <div id="seccion_cuatro">
        <table class="tabla">
          <tr class="firstline">
            <th colspan="8" class="section">DOMICILIO CORPORATIVO O PRINCIPAL ASIENTO DE NEGOCIOS</th>
          </tr>
          <div v-for="domicilio in currentCompareciente_.domicilios" :key="domicilio.id">
            <div v-if="domicilio.tipo == 'Particular' || domicilio.tipo == 'Particular y Fiscal'">
              <tr>
                <td class="title" style="width: 15%">Calle / Avenida / Vía:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.calle }}
                </td>
                <td colspan="1"></td>
                <td rowspan="8" class="maps" style="width: 50%" valign="center">
                  <img
                    width="auto"
                    height="180px"
                    :src="`https://maps.googleapis.com/maps/api/staticmap?center=${domicilio.lat},${
                      domicilio.lng
                    }&zoom=17&scale=1&size=600x300&maptype=roadmap&format=png&visual_refresh=true
                        &markers=color:red%7Alabel:C%7C${domicilio.lat},${domicilio.lng}
                        &key=${googleApiKey}`"
                  />
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Número Exterior:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.num_exterior }}
                </td>
                <td class="right-title" style="width: 7.5%">Interior:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.num_interior }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Alcaldía / Municipio:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.delegacion_municipio }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Entidad Federativa:</td>
                <td colspan="4" class="user" style="width: 30%">
                  {{ domicilio.entidad }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 15%">Colonia o Urbanización:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.colonia }}
                </td>
                <td class="right-title" style="width: 7.5%">CP:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.codigo_postal }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 7.5%">País:</td>
                <td colspan="2" class="user" style="width: 7.5%">
                  {{ domicilio.pais }}
                </td>
              </tr>
            </div>
          </div>
        </table>
      </div>

      <div id="seccion_cinco">
        <table class="tabla">
          <tr class="firstline">
            <th colspan="8" class="section">DOMICILIO FISCAL</th>
          </tr>
          <div v-for="domicilio in currentCompareciente_.domicilios" :key="domicilio.id">
            <div v-if="domicilio.tipo == 'Fiscal'">
              <tr>
                <td colspan="2" class="title" style="width: 15%">Calle / Avenida / Vía:</td>
                <td colspan="3" class="user" style="width: 30%">
                  {{ domicilio.calle }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="title" style="width: 15%">Número Exterior:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.num_exterior }}
                </td>
                <td class="right-title" style="width: 7.5%">Interior:</td>
                <td class="user" style="width: 7.5%">
                  {{ domicilio.num_interior }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="title" style="width: 15%">Alcaldía / Municipio:</td>
                <td colspan="3" class="user" style="width: 30%">
                  {{ domicilio.delegacion_municipio }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="title" style="width: 15%">Entidad Federativa:</td>
                <td colspan="3" class="user" style="width: 30%">
                  {{ domicilio.entidad }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="title" style="width: 15%">Colonia o Urbanización:</td>
                <td class="user" style="width: 15%">
                  {{ domicilio.colonia }}
                </td>
                <td class="right-title" style="width: 7.5%">CP:</td>
                <td class="user" style="width: 7.5%">
                  {{ domicilio.codigo_postal }}
                </td>
              </tr>
              <tr>
                <td class="title" style="width: 7.5%">País:</td>
                <td class="user" style="width: 7.5%">
                  {{ domicilio.pais }}
                </td>
              </tr>
            </div>
          </div>
        </table>
      </div>

      <div id="seccion_seis">
        <table class="tabla new-page">
          <tr class="firstline">
            <td colspan="4" class="section">DATOS DE CONTACTO DE LA PERSONA MORAL</td>
          </tr>
          <div v-if="currentCompareciente_.representantes.length > 0">
            <tr>
              <td class="title" style="width: 15%">Teléfono Fijo:</td>
              <td class="user" style="width: 35%">
                {{ currentCompareciente_.telefonoFijo }}
              </td>
              <td class="right-title" style="width: 15%">Persona de Contacto:</td>
              <td class="user" style="width: 35%">
                {{ currentCompareciente_.representantes[0].nombre }}
                {{ currentCompareciente_.representantes[0].paterno }}
                {{ currentCompareciente_.representantes[0].materno }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">Correo electrónico:</td>
              <td class="user" style="width: 35%">
                {{ currentCompareciente_.email }}
              </td>
              <td class="right-title" style="width: 15%">WhatsApp o Red Social:</td>
              <td class="user" style="width: 35%">No Aplica</td>
            </tr>
          </div>
        </table>
      </div>

      <div id="seccion_siete">
        <table class="tabla">
          <tr>
            <th colspan="8" class="section" style="width: 100%">DATOS GENERALES DEL APODERADO O REPRESENTANTE</th>
          </tr>
          <div v-if="currentCompareciente_.representantes.length > 0">
            <tr class="firstline">
              <td class="title" style="width: 15%">Nombre y apellidos:</td>
              <td colspan="7" class="user" style="width: 80%">
                {{ currentCompareciente_.representantes[0].nombre }}
                {{ currentCompareciente_.representantes[0].paterno }}
                {{ currentCompareciente_.representantes[0].materno }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">Fecha de Nacimiento:</td>
              <td colspan="3" class="user" style="width: 30%">
                <!-- {{ currentCompareciente_.representantes[0].fecha_nacimiento.substr(0, 10) }} -->
                {{ currentCompareciente_.representantes[0].fecha_nacimiento }}
              </td>
              <td class="right-title" style="width: 7.5%">Sexo:</td>
              <td class="user" style="width: 7.5%">No aplica</td>
              <td class="right-title" style="width: 10%">Alias/AKA:</td>
              <td class="user" style="width: 25%">No aplica</td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">Lugar de Nacimiento:</td>
              <td class="title" style="width: 7.5%">Ciudad:</td>
              <td class="user" style="width: 10%">
                {{ currentCompareciente_.representantes[0].lugar_nacim_ciudad }}
              </td>
              <td class="right-title" style="width: 7.5%">Estado:</td>
              <td colspan="2" class="user" style="width: 10%">
                {{ currentCompareciente_.representantes[0].lugar_nacim_estado }}
              </td>
              <td class="right-title" style="width: 10%">País:</td>
              <td class="user" style="width: 15%">
                {{ currentCompareciente_.representantes[0].lugar_nacim_pais }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">Nacionalidad:</td>
              <td colspan="7" class="user" style="width: 80%">
                {{ currentCompareciente_.representantes[0].nacionalidad }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">Actividad / Profesión:</td>
              <td colspan="3" class="user" style="width: 30%">
                {{ currentCompareciente_.representantes[0].ocupacion }}
              </td>
              <td colspan="2" class="right-title" style="width: 15%">Estado Civil:</td>
              <td colspan="2" class="user" style="width: 35%">
                {{ currentCompareciente_.representantes[0].estado_civil }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">CURP o equivalente:</td>
              <td colspan="3" class="user" style="width: 30%">
                {{ currentCompareciente_.representantes[0].curp }}
              </td>
              <td colspan="2" class="right-title" style="width: 15%">RFC o Tax ID:</td>
              <td colspan="2" class="user" style="width: 35%">
                {{ currentCompareciente_.representantes[0].rfc }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%">Identificación:</td>
              <td class="title" style="width: 7.5%">Tipo:</td>
              <td colspan="2" class="user" style="width: 12.5%">
                {{ currentCompareciente_.representantes[0].identificacion_tipo }}
              </td>
              <td colspan="2" class="right-title" style="width: 15%">Autoridad que expide:</td>
              <td colspan="2" class="user" style="width: 35%">
                {{ currentCompareciente_.representantes[0].identificacion_autoridad }}
              </td>
            </tr>
            <tr>
              <td class="title" style="width: 15%"></td>
              <td class="title" style="width: 7.5%">Número:</td>
              <td colspan="6" class="user" style="width: 72.5%">
                {{ currentCompareciente_.representantes[0].identificacion_numero }}
              </td>
            </tr>
          </div>
        </table>
      </div>

      <div id="seccion_ocho">
        <table class="tabla">
          <tr class="firstline">
            <td colspan="9" class="section">DATOS DEL PODER</td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Instrumento Número:</td>
            <td colspan="3" class="user" style="width: 20%">
              {{ currentCompareciente_.instrumento_numero }}
            </td>
            <td class="right-title" style="width: 15%">De fecha:</td>
            <td colspan="2" class="user" style="width: 17.5%">
              <!-- {{ currentCompareciente_.instrumento_numero_fecha.substr(0, 10) }} -->
              {{ currentCompareciente_.instrumento_numero_fecha }}
            </td>
            <td class="right-title" style="width: 10%">Fedatario:</td>
            <td class="user" style="width: 22.5%">
              {{ currentCompareciente_.instrumento_fedatario }}
            </td>
          </tr>
          <tr>
            <td class="title" style="width: 15%">Nombre del Fedatario:</td>
            <td colspan="4" class="user" style="width: 35%">
              {{ currentCompareciente_.instrumento_fedatario_nombre }}
            </td>
            <td class="right-title" style="width: 8.75%">Número</td>
            <td class="user" style="width: 8.75%">
              {{ currentCompareciente_.instrumento_fedatario_numero }}
            </td>
            <td class="right-title" style="width: 10%">Lugar:</td>
            <td class="user" style="width: 22.5%">
              {{ currentCompareciente_.instrumento_fedatario_estado }}
            </td>
          </tr>
          <tr>
            <td colspan="2" class="title" style="width: 30%">Datos de Inscripción en el RPC - Folio Número:</td>
            <td colspan="3" class="user" style="width: 20%">
              {{ currentCompareciente_.instrumento_rpf_folio }}
            </td>
            <td colspan="2" class="right-title" style="width: 17.5%">Fecha y Lugar:</td>
            <td colspan="2" class="user" style="width: 32.5%">
              <!-- {{ currentCompareciente_.instrumento_rpf_folio_fecha.substr(0, 10) }} -->
              {{ currentCompareciente_.instrumento_rpf_folio_fecha }}
              {{ currentCompareciente_.instrumento_rpf_folio_lugar }}
            </td>
          </tr>
          <!-- <tr>
                <td class="title" style="width: 20%;">
                    Tipo de representación o cargo:
                </td>
                <td colspan="4" class="user" style="width: 30%;">
                        Representante
                </td>
                <td class="right-title" style="width: 8.75%;">
                    Limitación:
                </td>
                <td colspan="4" class="user" style="width: 41.25;">
                    Limitante
                </td>
            </tr> -->
        </table>
      </div>

      <div id="seccion_nueve">
        <table class="tabla">
          <tr class="firstline">
            <td colspan="8" class="section">EN CASO DE PERSONAS MORALES EXTRANJERAS: DOMICILIO DE CONTACTO EN MÉXICO</td>
          </tr>
          <div v-for="domicilio in currentCompareciente_.domicilios" :key="domicilio.id">
            <div v-if="domicilio.tipo == 'Extranjero'">
              <div v-if="domicilio.calle === 'No aplica'">
                <table class="tabla" style="border-collapse: collapse !important">
                  <tr class="section-empty">
                    <td>No aplica</td>
                  </tr>
                </table>
              </div>
              <div v-else>
                <tr>
                  <td class="title" style="width: 15%">Calle / Avenida / Vía:</td>
                  <td colspan="3" class="user" style="width: 35%">
                    {{ domicilio.calle }}
                  </td>
                  <td class="right-title" style="width: 10%">Num Exterior:</td>
                  <td class="user" style="width: 20%">
                    {{ domicilio.num_exterior }}
                  </td>
                  <td class="right-title" style="width: 10%">Num. Interior:</td>
                  <td class="user" style="width: 10%">
                    {{ domicilio.num_interior }}
                  </td>
                </tr>
                <tr>
                  <td class="title" style="width: 15%">Colonia o Urbanización:</td>
                  <td colspan="3" class="user" style="width: 35%">
                    {{ domicilio.colonia }}
                  </td>
                  <td class="right-title" style="width: 10%">Alcaldía / Municipio:</td>
                  <td colspan="3" class="user" style="width: 40%">
                    {{ domicilio.delegacion_municipio }}
                  </td>
                </tr>
                <tr>
                  <td class="right-title" style="width: 10%">Código Postal:</td>
                  <td class="user" style="width: 10%">
                    {{ domicilio.codigo_postal }}
                  </td>
                  <td class="right-title" style="width: 10%">Entidad Federativa:</td>
                  <td colspan="3" class="user" style="width: 40%">
                    {{ domicilio.entidad }}
                  </td>
                </tr>
                <tr>
                  <td class="title" style="width: 15%; vertical-align: top">Datos del documento constitutivo:</td>
                  <td
                    colspan="7"
                    class="verifycheck"
                    style="text-align: left; vertical-align: top; font-weight: lighter; font-size: 12px; width: 65%; height: 80px"
                  >
                    {{ currentCompareciente_.datos_prueba_constitucion }}
                  </td>
                </tr>
              </div>
            </div>
          </div>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "KycTemplate",

  props: {
    currentCompareciente: { type: Object }
  },

  created() {
    // clona el objeto
    this.currentCompareciente_ = structuredClone(this.currentCompareciente);

    this.currentCompareciente_.fecha_nacimiento = this.currentCompareciente_.fecha_nacimiento.substring(0, 10);
    this.setNoAplicas();
  },

  data() {
    return {
      fecha: new Intl.DateTimeFormat("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }).format(new Date()),

      currentCompareciente_: {},

      urlBanner: config.CD_STG_BASE_URL + "/cp_color_banner.jpg" + config.CD_STG_ACCESS_KEY,
      googleApiKey: config.CD_GOOGLE_MAPS_API_KEY,
      stgAccessKey: config.CD_STG_ACCESS_KEY,
    };
  },

  components: {},

  computed: {},

  methods: {
    setNoAplicas() {
      const keys = Object.keys(this.currentCompareciente_);

      for (let i = 0; i < keys.length; i++) {
        if (!this.currentCompareciente_[keys[i]]) {
          this.currentCompareciente_[keys[i]] = "No aplica";
        }
      }

      const celular = this.currentCompareciente_.telefonos.find((t) => t.tipo === "Celular");
      if (celular) {
        this.currentCompareciente_.telefonoCelular = celular.clave + " " + celular.numero;
      } else {
        this.currentCompareciente_.telefonoCelular = "No aplica";
      }

      const fijo = this.currentCompareciente_.telefonos.find((t) => t.tipo === "Teléfono");
      if (fijo) {
        this.currentCompareciente_.telefonoFijo = fijo.clave + " " + fijo.numero;
      } else {
        this.currentCompareciente_.telefonoFijo = "No aplica";
      }

      if (this.currentCompareciente_.persona == "Persona Física" || this.currentCompareciente_.persona == "Física") {
        if (this.currentCompareciente_.domicilios.length > 0) {
          const domicilioParticular = this.currentCompareciente_.domicilios.find(
            (domicilio) => domicilio.tipo == "Particular y Fiscal",
          );

          if (domicilioParticular) {
            const index = this.currentCompareciente_.domicilios.findIndex((domicilio) => domicilio.tipo == "Particular y Fiscal");
            const domi_fiscal = Object.assign({}, this.currentCompareciente_.domicilios[index]);
            // let domi_fiscal = this.currentCompareciente_.domicilios[index];
            domi_fiscal.tipo = "Fiscal";
            domi_fiscal.id = null;
            this.currentCompareciente_.domicilios.push(domi_fiscal);
          }

          let domicilio_extranjero = this.currentCompareciente_.domicilios.find((domicilio) => domicilio.tipo == "Extranjero");

          if (!domicilio_extranjero) {
            let domicilio_extranjero_na = {
              id: 467,
              calle: "No aplica",
              num_exterior: "No aplica",
              num_interior: "No aplica",
              colonia: "No aplica",
              delegacion_municipio: "No aplica",
              ciudad: "No aplica",
              entidad: "No aplica",
              pais: "No aplica",
              codigo_postal: "No aplica",
              tipo: "Extranjero",
              // lat: "19.4279485",
              // lng: "-99.15618719999999"
            };
            this.currentCompareciente_.domicilios.push(domicilio_extranjero_na);
          }
        }

        if (
          !this.currentCompareciente_.representantes ||
          (Array.isArray(this.currentCompareciente_.representantes) && this.currentCompareciente_.representantes.length === 0)
        ) {
          this.currentCompareciente_.representantes = "No aplica";
        }

        if (this.currentCompareciente_.representantes !== "No aplica") {
          if (this.currentCompareciente_.representantes[0].domicilios.length == 0) {
            //añade uno de No aplica
            const domicilio_na = {
              // id: 467,
              calle: "No aplica",
              num_exterior: "No aplica",
              num_interior: "No aplica",
              colonia: "No aplica",
              delegacion_municipio: "No aplica",
              ciudad: "No aplica",
              entidad: "No aplica",
              pais: "No aplica",
              codigo_postal: "No aplica",
              tipo: "Particular y Fiscal",
              // lat: "19.4279485",
              // lng: "-99.15618719999999"
            };
            this.currentCompareciente_.representantes[0].domicilios.push(domicilio_na);
          }
        }
      } else if (this.currentCompareciente_.persona == "Persona Moral" || this.currentCompareciente_.persona == "Moral") {
        if (this.currentCompareciente_.domicilios.length > 0) {
          let domicilioParticular = this.currentCompareciente_.domicilios.find(
            (domicilio) => domicilio.tipo == "Particular y Fiscal",
          );
          if (domicilioParticular != null) {
            let index = this.currentCompareciente_.domicilios.findIndex((domicilio) => domicilio.tipo == "Particular y Fiscal");
            let domi_fiscal = Object.assign({}, this.currentCompareciente_.domicilios[index]);
            // let domi_fiscal = this.currentCompareciente_.domicilios[index];
            domi_fiscal.tipo = "Fiscal";
            domi_fiscal.id = null;
            this.currentCompareciente_.domicilios.push(domi_fiscal);
          }

          let domicilio_extranjero = this.currentCompareciente_.domicilios.find((domicilio) => domicilio.tipo == "Extranjero");
          if (domicilio_extranjero == null) {
            let domicilio_extranjero_na = {
              id: 467,
              calle: "No aplica",
              num_exterior: "No aplica",
              num_interior: "No aplica",
              colonia: "No aplica",
              delegacion_municipio: "No aplica",
              ciudad: "No aplica",
              entidad: "No aplica",
              pais: "No aplica",
              codigo_postal: "No aplica",
              tipo: "Extranjero",
              // lat: "19.4279485",
              // lng: "-99.15618719999999"
            };
            this.currentCompareciente_.domicilios.push(domicilio_extranjero_na);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.maps {
  text-align: center;
  vertical-align: middle;
}

.new-page {
  /* page-break-before: always; */
  break-before: page;
}

.logo {
  width: auto;
  height: 100px;
  float: right;
}

.tabla {
  width: 100%;
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: separate;
  border-spacing: 0 1em;
}

.section {
  background-color: #4bacc6;
  color: #fff;
  text-align: center;
  height: 40px;
  font-weight: bolder;
}

.section-empty {
  text-align: center;
  font-weight: bolder;
  font-size: 18px;
}

.firstline {
  border: 5px solid #fff;
}

.title {
  font-size: 12px;
  text-align: left;
  width: 20%;
  font-weight: 700;
}

.select {
  text-align: left;
  width: 5%;
}

.circle {
  border-radius: 100%;
  height: 15px;
  width: 15px;
  border: 2px solid #4bacc6;
  margin-bottom: 0;
}

.filledcircle {
  border-radius: 100%;
  height: 15px;
  width: 15px;
  border: 2px solid #4bacc6;
  background-color: #4bacc6;
  margin-bottom: 0;
}

.verifycheck {
  border: 2px solid #4bacc6;
  background-color: #e7eef5;
  text-align: center;
}

.right-title {
  font-size: 12px;
  text-align: right;
  font-weight: 700;
}

.user {
  text-align: left;
  font-size: 12px;
  font-weight: lighter;
  border-bottom: solid 1px #000;
  background-color: #e7eef5;
}

.leyenda {
  font-size: 9px;
}
</style>
